(function () {
  'use strict';

  class ModalDetalhesRotogramaCtrl {
    constructor(PontosReferencia, AlertMessage, ControleVelocidadeRotograma, $translate) {
      this.pontoReferenciaService = PontosReferencia;
      this.alertMessage = AlertMessage;
      this.controleVelocidadeRotograma = ControleVelocidadeRotograma;
      this.translate = $translate;

      this.KEEP_SPEED_STATUS = [
        this.controleVelocidadeRotograma.UTILIZA_VELOCIDADE_ANTERIOR.value,
        this.controleVelocidadeRotograma.KEEP_SPEED_AND_AUDIO.value
      ];
    }

    $onInit() {
      this.velocidadePadrao = this.resolve.velocidade;
      this.audio = this.resolve.audio ? this.resolve.audio.nome : null;
      this.status = this.resolve.status;
      this.pontoReferenciaService.getRotograma(this.resolve.id)
      .then(data => {
        this.model = data.plain();
      })
      .catch(() => {
        this.alertMessage.create({
          type: 'error',
          message: this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.errorCarregarRotograma'),
          appendTo: '.alerta-aqui-rotograma-ponto'
        });
      });
    }

    getTitle() {
      if (this.audio && this.velocidadePadrao || this.controleVelocidadeRotograma.KEEP_SPEED_AND_AUDIO.value === this.status) {
        return 'ce.mapa.common.modal.modalDetalhesRotograma.tituloVelocidadeEAudio';
      }
      if (this.audio) {
        return 'ce.mapa.common.modal.modalDetalhesRotograma.tituloAudio';
      }
      return 'ce.mapa.common.modal.modalDetalhesRotograma.titulo';
    }

    getDescricao() {
      const speedDescription = this.velocidadePadrao ? `<p>${this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.descricaoPadrao')}: <strong>${this.velocidadePadrao} km/h</strong></p>` : '',
          audioDescription = this.audio ? `<p>${this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.descricaoAudio')}: <strong>${this.audio}</strong></p>` : '';

      if (this.KEEP_SPEED_STATUS.includes(this.status)) {
        const keepSpeedDescription = `<p>${this.translate.instant('ce.mapa.common.modal.modalDetalhesRotograma.descricaoVelocidadeAnterior')}</p>`;
        if (this.audio) {
          return keepSpeedDescription + '<br>' + audioDescription;
        }
        return keepSpeedDescription;
      }

      return speedDescription + audioDescription;
    }
  }

  angular
    .module('mapControlModule')
    .component('modalDetalhesRotograma', {
      controller: ModalDetalhesRotogramaCtrl,
      templateUrl: 'directives/map-control/rotograma-ponto-referencia/modal-detalhes-rotograma.tpl.html',
      bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
      }
    });
}());
